export const GETALLNOTIFICATIONS = 'GETALLNOTIFICATIONS'
export const GETALLNOTIFICATIONSETTING = 'GETALLNOTIFICATIONSETTING'
export const GETALLUSERS = 'GETALLUSERS'
export const GETALLUSERGROUPS = 'GETALLUSERGROUPS'
